import path from 'ramda/src/path'
import over from 'ramda/src/over'
import lensProp from 'ramda/src/lensProp'
import map from 'ramda/src/map'
import is from 'ramda/src/is'

import moduleDescriptions from 'root/src/shared/descriptions/modules'

const routeIdResolve = (content, state) => {
	if (content?.buttons) {
		return over(
			lensProp('buttons'),
			map((button) => {
				if (typeof button.routeId === 'function') {
					return { ...button, routeId: button.routeId(state) }
				}
				return button
			}),
			content,
		)
	}
	return content
}

export default (state, { moduleId }) => {
	const pageContent = path([moduleId, 'pageContent'], moduleDescriptions)
	return is(Array, pageContent)
		? map(part => routeIdResolve(part, state), pageContent)
		: routeIdResolve(pageContent, state)
}
